// import React, { useCallback, useEffect, useRef, useState } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { toast } from "react-toastify";
// import { useSelector } from "react-redux";

// const MAIN_TAB_LOCK_KEY = "iq_main_active_tab";
// const TOKEN_KEY = "token";
// const USER_INFO_KEY = "userInfo";
// const USER_KEY = "user";
// const LOGOUT_BASE_URL = `${process.env.REACT_APP_BASE_URL}/admin/v1/auth/logout`;

// const generateTabId = () => `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

// export default function isUserLoggedIn(Component) {
//     return function IsAuth(props) {
//         const navigate = useNavigate();
//     const location = useLocation();
//     const { pathname } = location || {};
//     const tabIdRef = useRef(generateTabId());
//     const hasReleasedRef = useRef(false);
//     const [isAuthorizedTab, setIsAuthorizedTab] = useState(false);
//     const [isSessionResolved, setIsSessionResolved] = useState(false);
//     const userId = useSelector((state) => state?.users?.userInfo?._id);
//     const logoutEndpoint = userId ? `${LOGOUT_BASE_URL}/${userId}` : null;

//     const clearSessionData = useCallback(
//       ({ includeSessionStorage = false } = {}) => {
//         if (includeSessionStorage) {
//           try {
//             sessionStorage.removeItem(TOKEN_KEY);
//             sessionStorage.removeItem(USER_INFO_KEY);
//             sessionStorage.removeItem(USER_KEY);
//           } catch (error) {
//             // ignore sessionStorage errors
//           }
//         }
//         try {
//           localStorage.removeItem(TOKEN_KEY);
//           localStorage.removeItem(USER_INFO_KEY);
//           localStorage.removeItem(USER_KEY);
//         } catch (error) {
//           // ignore localStorage errors
//         }
//       },
//       []
//     );

//     const syncAuthFromSession = useCallback(() => {
//       try {
//         const localToken = localStorage.getItem(TOKEN_KEY);
//         const sessionToken = sessionStorage.getItem(TOKEN_KEY);

//         // If token exists in localStorage (e.g. after login from another tab),
//         // ensure this tab also has a sessionStorage copy.
//         if (localToken && !sessionToken) {
//           sessionStorage.setItem(TOKEN_KEY, localToken);
//         }

//         // If for some reason only sessionStorage has it, mirror back to localStorage.
//         if (!localToken && sessionToken) {
//           localStorage.setItem(TOKEN_KEY, sessionToken);
//         }

//         const localUser = localStorage.getItem(USER_KEY);
//         const sessionUser = sessionStorage.getItem(USER_KEY);
//         if (localUser && !sessionUser) {
//           sessionStorage.setItem(USER_KEY, localUser);
//         } else if (!localUser && sessionUser) {
//           localStorage.setItem(USER_KEY, sessionUser);
//         }

//         const localUserInfo = localStorage.getItem(USER_INFO_KEY);
//         const sessionUserInfo = sessionStorage.getItem(USER_INFO_KEY);
//         if (localUserInfo && !sessionUserInfo) {
//           sessionStorage.setItem(USER_INFO_KEY, localUserInfo);
//         } else if (!localUserInfo && sessionUserInfo) {
//           localStorage.setItem(USER_INFO_KEY, sessionUserInfo);
//         }
//       } catch (error) {
//         // ignore sync issues (e.g. disabled storage)
//       }
//     }, []);

//     const notifyServerLogout = useCallback(
//       (token) => {
//         if (!logoutEndpoint || !token) {
//           return;
//         }

//         try {
//           fetch(logoutEndpoint, {
//             method: "PATCH",
//             headers: {
//               "Content-Type": "application/json",
//               authorization: `Bearer ${token}`,
//             },
//             keepalive: true,
//           }).catch(() => {
//             // swallow network errors
//           });
//         } catch (error) {
//           // ignore fetch setup errors
//         }
//       },
//       [logoutEndpoint]
//     );

//     const releaseMainTabLock = useCallback(
//       ({ clearSession } = { clearSession: false }) => {
//         const ownsLock = localStorage.getItem(MAIN_TAB_LOCK_KEY) === tabIdRef.current;

//         if (clearSession) {
//           const token =
//             localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);
//           notifyServerLogout(token);
//         }

//         if (ownsLock) {
//           localStorage.removeItem(MAIN_TAB_LOCK_KEY);
//         }
//         if (clearSession) {
//           clearSessionData();
//         }
//       },
//       [clearSessionData, notifyServerLogout]
//     );

//     const claimMainTabLock = useCallback(() => {
//       localStorage.setItem(MAIN_TAB_LOCK_KEY, tabIdRef.current);
//       setIsAuthorizedTab(true);
//       setIsSessionResolved(true);
//     }, []);

//     const redirectToSignIn = useCallback(
//       (message) => {
//         if (message) {
//           toast.warn(message);
//         }
//         setIsAuthorizedTab(false);
//         setIsSessionResolved(true);
//         navigate("/auth/signin", {
//           replace: true,
//           state: { from: location?.pathname || "/main" },
//         });
//       },
//       [navigate, pathname]
//     );

//     useEffect(() => {
//       syncAuthFromSession();
//       const token = localStorage.getItem("token");

//       if (!token) {
//         releaseMainTabLock();
//         redirectToSignIn();
//         return;
//       }

//       const activeTabId = localStorage.getItem(MAIN_TAB_LOCK_KEY);

//       if (!activeTabId) {
//         claimMainTabLock();
//         return;
//       }

//       if (activeTabId === tabIdRef.current) {
//         setIsAuthorizedTab(true);
//         setIsSessionResolved(true);
//         return;
//       }

//       redirectToSignIn("Admin panel is already active in another tab.");
//     }, [navigate, pathname, claimMainTabLock, releaseMainTabLock, redirectToSignIn, syncAuthFromSession]);

//         useEffect(() => {
//       const handleStorageChange = (event) => {
//         if (event.key !== MAIN_TAB_LOCK_KEY) {
//           return;
//         }

//         if (!event.newValue) {
//           const token = localStorage.getItem("token");
//           if (token && !isAuthorizedTab) {
//             claimMainTabLock();
//           }
//           return;
//         }

//         if (event.newValue !== tabIdRef.current && isAuthorizedTab) {
//           setIsAuthorizedTab(false);
//           setIsSessionResolved(true);
//           redirectToSignIn("Detected another active session.");
//         }
//       };

//       window.addEventListener("storage", handleStorageChange);
//       return () => {
//         window.removeEventListener("storage", handleStorageChange);
//       };
//     }, [isAuthorizedTab, claimMainTabLock, redirectToSignIn]);

//     useEffect(() => {
//       const releaseLockAndClearSession = () => {
//         if (hasReleasedRef.current) {
//           return;
//         }
//         hasReleasedRef.current = true;
//         releaseMainTabLock({ clearSession: true });
//       };

//       const releaseLockWithoutClear = () => {
//         if (hasReleasedRef.current) {
//           return;
//         }
//         hasReleasedRef.current = true;
//         releaseMainTabLock();
//       };

//       window.addEventListener("beforeunload", releaseLockAndClearSession);
//       window.addEventListener("pagehide", releaseLockAndClearSession);

//       return () => {
//         window.removeEventListener("beforeunload", releaseLockAndClearSession);
//         window.removeEventListener("pagehide", releaseLockAndClearSession);
//         releaseLockWithoutClear();
//       };
//     }, [releaseMainTabLock]);

//     if (!isSessionResolved || !isAuthorizedTab) {
//       return null;
//     }

//         return <Component {...props} />;
//     };
// }



import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function isUserLoggedIn(Component) {
    return function IsAuth(props) {
        const loggedIn = localStorage.getItem("token") ? true : false
        const navigate = useNavigate();

        useEffect(() => {
            if (!loggedIn) {
                navigate("/auth/signin")
            }
            else {
                // navigate("/main")
            }


        }, [loggedIn]);


        return <Component {...props} />;
    };
}